export const frontmatter = {
    "draft": true,
    "title": "Autenticación",
    "description": "Autenticación en la API de OnnIA.",
    "sidebar_label": "Autenticación",
    "sidebar_group": "referencia",
    "sidebar_order": 1
}

export const toc = []